<template lang="pug">
	div.container-fluid
		.card
			.card-header
				span.fa.fa-search.mr-2
				| Filtro
			.card-body
				.row
					.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
						.form-group
							label
								b Usuario
							//
								input-query.form-control.form-control-sm(
									inputClass="form-control.form-control-sm"
									v-if="!filtro.UsuarioID"
									placeholder="Busca un usuario"
									@selected="setUsuario($event)"
									:realtime="true"
									url="gestion-jornada/php/api/queryUsuarios.php"
								)
							seleccion-usuario(v-model="filtro.UsuarioID" :readonly="!permisos.gestion_jornada_verTodos")
					.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
						.form-group
							label
								b Mes
							datepicker(
								v-model="fecha"
								inputClass="form-control form-control-sm"
								:bootstrap-styling="true"
								minimum-view="month"
								format="MMMM, yyyy"
								:language="$dateLang"
							)
			.card-footer
				button.btn.btn-primary.mr-2(@click="buscar()")
					span.fa.fa-search.mr-2
					| Buscar
				button.btn.btn-warning(@click="cerrarMes()")
					span.fa.fa-calendar.mr-2
					| Cerrar mes
		.card.mt-3
			.card-header.bg-dark.text-white
				span.fa.fa-table.mr-2
				| Informes
			table.table.table-striped.m-0(v-if="cierres.length > 0")
				thead
					tr
						th Usuario
						th Mes
						th Total jornada
						th Horas trabajadas
						th Extras
						th Nocturnas
						th Festivas
						th Faltas justificadas
						th Horas libradas
						th Vacaciones
						th
				tbody
					tr(
						v-for="cierre in cierres"
						:key="cierre.CierreID"
					)
						td {{cierre.UsuarioNombre}}
						td {{cierre.MesUnix | moment('MMMM, YYYY')}}
						td {{cierre.SegundosTrabajados + cierre.SegundosNoTrabajados | hora}}
						td {{cierre.SegundosTrabajados | hora}}
						td {{cierre.SegundosExtra | hora}}
						td {{cierre.SegundosNocturnos | hora}}
						td {{cierre.SegundosFestivos | hora}}
						td {{cierre.Falta | hora}}
						td {{cierre.Libre | hora}}
						td {{cierre.Vacaciones}} días
						td
							button.btn.btn-sm.btn-danger.mr-2(
								title="Revertir cierre"
								v-if="permisos.gestion_jornada_editarTodos"
								@click="revertirCierre(cierre)"
							)
								span.fa.fa-undo
							button.btn.btn-sm.btn-primary(@click="getPDF(cierre)")
								span.fa.fa-file-pdf-o
			.card-body.text-center(v-else)
				h2 No hay datos

		Cierre(v-if="cerrandoMes", @cerrar="cerrarMes()")
</template>

<script>
import axios from 'axios'
import Cierre from './cierre'
import { mapGetters } from 'vuex'
export default {
	components: {
		Cierre
	},
	data () {
		return {
			fecha: new Date(),
			filtro: {
				UsuarioID: null,
				mes: this.$moment().format('YYYY-MM-DD')
			},
			cierres: [],
			cerrandoMes: false,
			UsuarioNombre: null
		}
	},
	watch: {
		fecha: function (newVal) {
			this.filtro.mes = this.$moment(newVal).format('YYYY-MM-DD')
			this.buscar()
		}
	},
	created () {
		this.filtro.UsuarioID = this.usuario.ID
		this.UsuarioNombre = this.usuario.nombre + ' ' + this.usuario.apellidos
	},
	computed: {
		...mapGetters({
			permisos: 'permisos/permisos',
			usuario: 'session/usuario'
		})
	},
	methods: {
		setUsuario (e) {
			this.filtro.UsuarioID = e.datos.ID
			this.UsuarioNombre = e.datos.nombre + ' ' + e.datos.apellidos
		},
		cerrarMes () {
			this.cerrandoMes = !this.cerrandoMes

			if (!this.cerrandoMes) {
				this.buscar()
			}
		},
		getPDF (cierre) {
			this.download('gestion-jornada/php/api/getPDF.php', {UsuarioID: cierre.UsuarioID, Mes: cierre.Mes}, 'informe.pdf')
		},
		buscar () {
			axios.post('gestion-jornada/php/api/getCierres.php', this.filtro)
				.then(res => {
					this.cierres = res.data
				})
				.catch(e => {
					this.$error('Error', e.response.data.error)
				})
		},
		revertirCierre (cierre) {
			this.$store.commit('alertas/confirm', {
				titulo: 'Revertir cierre',
				mensaje: '¿Quieres revertir el cierre de este usuario?',
				callback: acepta => {
					if (acepta) {
						const form = {
							UsuarioID: cierre.UsuarioID,
							ano: parseInt(cierre.Mes.split('-')[0]),
							mes: parseInt(cierre.Mes.split('-')[1])
						}
						axios.post('gestion-jornada/php/api/revertirCierre.php', form)
							.then(() => {
								this.$store.commit('toast/success', {
									titulo: 'Cierre revertido'
								})
								this.buscar()
							})
							.catch((e) => {
								this.$store.commit('alertas/error', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-jornada/vue/components/informes/informes.vue